import * as Sentry from '@sentry/react';
import { db } from '../db';
import type { CachedSoilMyGroup } from '../db';
import { soilGroupService } from './soilGroupService';

/**
 * Soil application group worklist cache (issue #417 Slice 4).
 *
 * Mirrors nutritionOperatorSessionCacheService's refresh/read pair: the
 * worklist is a flat snapshot, so each refresh is a clean clear + bulkPut. On a
 * network failure the cache is left intact so an offline operator still sees
 * their last-known work.
 */
export async function refreshMySoilGroups(): Promise<{ hasLinkedOperator: boolean }> {
  return Sentry.startSpan(
    { name: 'nutrition.cache.refreshMySoilGroups', op: 'cache.sync' },
    async () => {
      let rows: CachedSoilMyGroup[];
      let hasLinkedOperator: boolean;
      try {
        const data = await soilGroupService.listMyGroups();
        const cachedAt = new Date().toISOString();
        rows = data.items.map((item) => ({ ...item, cachedAt }));
        hasLinkedOperator = data.hasLinkedOperator;
      } catch (_err) {
        return { hasLinkedOperator: false };   // offline — leave the cache alone
      }

      await db.transaction('rw', db.soilMyGroups, async () => {
        await db.soilMyGroups.clear();
        await db.soilMyGroups.bulkPut(rows);
      });

      return { hasLinkedOperator };
    },
  );
}

export async function readCachedMySoilGroups(): Promise<CachedSoilMyGroup[]> {
  return db.soilMyGroups.toArray();
}
